import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

const redirect = (basePath, id, data) => `/farms`;

export default (props) => (
  <Create title="Create a new Farm" {...props}>
    <SimpleForm redirect={redirect}>
      <TextInput source="name" />
      <TextInput
        source="identifier"
        helperText="Devine literal segmentul de farm din topicul MQTT (italscada/v1/<identifier>/<turbina>/...) - scurt, unic, fără slash-uri."
      />
    </SimpleForm>
  </Create>
);
